import * as THREE from "three";
import * as ZapparThree from "@zappar/zappar-threejs";
import "./style.css";
import "./dom/button.ts";

import { hideFacePrompt, hideSplash, revealFacePrompt, revealIntroRoarPrompt } from "./dom";
import { initWatermarks } from "./components/watermarks";
import { initTabVisibiltyListenerForAudio, initVideoRecorder, resumeAudioContext, stopRecording } from "./components/videoRecorderAndAudio";
import { animationDuckUpdates, initRoom } from "./components/room";
import { animationElmoUpdates, initElmo } from "./components/elmo";
import { animationUserSuitUpdates, initUserSuit } from "./components/userSuit";
import {
  checkOpenMouth,
  disableMouthLandmarks,
  enableMouthLandmarks,
  initMouthLandmarks,
} from "./components/mouthLandmarks";
import { initLights } from "./components/lights";
import { flipCamera, initCamera } from "./components/camera";
import { initRenderer } from "./components/renderer";
import { initMask, maskUpdate } from "./components/mask";
import { initFace, renderFace } from "./components/face";
import {
  faceTrackerForSmallerFaceUpdates,
  hideFaceTrackerForSmallerFace,
  initFaceTrackerForSmallerFace,
  revealFaceTrackerForSmallerFace,
} from "./components/faceTrackerForSmallerFace";
import { initRoar } from "./components/roar";

const manager = new ZapparThree.LoadingManager();
const renderer = initRenderer();
const camera = initCamera();

const scene = new THREE.Scene();
let texture = camera.backgroundTexture;
texture.repeat;
scene.background = texture;

const faceTracker = new ZapparThree.FaceTrackerLoader(manager).load();
const faceTrackerGroup = new ZapparThree.FaceAnchorGroup(camera, faceTracker);
scene.add(faceTrackerGroup);
faceTrackerGroup.visible = false;
let faceTrackerForSmallerFace = initFaceTrackerForSmallerFace(scene);

faceTracker.onVisible.bind(anchor => {
  faceTrackerGroup.visible = true;
  revealFaceTrackerForSmallerFace();
  hideFacePrompt();
  enableMouthLandmarks();
});

faceTracker.onNotVisible.bind(anchor => {
  faceTrackerGroup.visible = false;
  hideFaceTrackerForSmallerFace();
  revealFacePrompt();
  disableMouthLandmarks();
  stopRecording();
});

//temporary
// let onScreenGroup = new THREE.Group();
// scene.add(onScreenGroup)
// onScreenGroup.scale.set(0.3,0.3,0.3)
// onScreenGroup.rotation.y = -Math.PI/10;
// onScreenGroup.position.z = -6;

initMask(faceTrackerGroup);
initWatermarks(scene);
initRoar(scene);
initRoom(faceTrackerForSmallerFace, manager, scene);
initElmo(faceTrackerForSmallerFace, manager, scene);
initUserSuit(faceTrackerForSmallerFace, faceTrackerGroup);
initMouthLandmarks(scene, camera, faceTracker);
initLights(faceTrackerForSmallerFace, scene);
initFace(camera, renderer, faceTracker, faceTrackerGroup, faceTrackerForSmallerFace);
initTabVisibiltyListenerForAudio();

renderer.setAnimationLoop(render);
function render() {
  camera.updateFrame(renderer);
  maskUpdate(faceTrackerGroup);
  faceTrackerForSmallerFaceUpdates(faceTrackerGroup);
  animationElmoUpdates();
  animationUserSuitUpdates();
  animationDuckUpdates();
  renderFace();
  checkOpenMouth();
  renderer.render(scene, camera);
}

export function launch() {
  ZapparThree.permissionRequest().then(async granted => {
    if (granted) {
      initVideoRecorder(renderer);
      startExperience();
    } else {
      ZapparThree.permissionDeniedUI();
    }
  });
}

//
// export function launch() {
//   navigator.mediaDevices.getUserMedia({ video: true, audio: true })
//     .then(function (stream) {
//       startExperience()
//     })
//     .catch(function (err) {
//       ZapparThree.permissionDeniedUI();
//       // alert('Please refresh browser and accept mircophone permissions to continue')
//     });
// }

// export function microphonePermissionRequest(){
//   navigator.mediaDevices.getUserMedia( {audio : true} )
//   .then(function(stream) {
//     audioRequest()
//   })
//   .catch(function(err) {
//     alert('Please refresh browser and accept mircophone permissions to continue')
//   });
// }

// const getMicrophonePermission = async () => {
//   if ("MediaRecorder" in window) {
//       try {
//           alert('media recorder in window');
//           startExperience()
//       } catch (err) {
//           alert('error');
//       }
//   } else {
//     alert("The MediaRecorder API is not supported in your browser.");
//   }
// };

// navigator.permissions.query({ name: "microphone" }).then((result) => {
//   if (result.state === "granted") {

//   } else if (result.state === "prompt") {
//     ZapparThree.permissionDeniedUI();
//   }
// });

function startExperience() {
  camera.start(false);

  hideSplash();
  revealIntroRoarPrompt();
  resumeAudioContext();
}
